import sizes from '../../../../theme/foundations/sizes'
import {pxToRem} from '../../../../utills/pxToRem'

export const formStyles = {
    marginTop: `0 !important`,
    label: {
        marginTop: pxToRem(20),
        marginBottom: {base: pxToRem(5), lg: pxToRem(10)},
        fontSize: {base: `${pxToRem(12)} !important`, lg: `${pxToRem(13)} !important`},
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: pxToRem(1),
        color: 'black'
    },
    input: {
        fontSize: {base: `${pxToRem(12)} !important`, lg: `${pxToRem(13)} !important`},
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: pxToRem(1),
        color: 'black'
    },
    span: {
        textTransform: 'none'
    }
}

export const displayMyStoreDetailStyles = {
    'p, a': {
        fontSize: {base: pxToRem(12), lg: pxToRem(13)},
        lineHeight: 'normal',
        letterSpacing: pxToRem(1),
        marginBottom: pxToRem(5)
    },
    p: {
        color: 'black'
    }
}

export const updatePasswordFieldsStyles = {
    label: {
        color: 'black',
        marginBottom: pxToRem(10),
        marginTop: pxToRem(10),
        fontSize: {base: pxToRem(12), lg: pxToRem(13)},
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: pxToRem(1),
        fontWeight: 400
    },
    input: {
        borderRadius: 0
    },
    p: {
        margin: 0
    }
}

export const cardStyles = {
    '.button-primary, .button-outline': {
        minWidth: {base: '100%', md: '100%', lg: '100%'}
    }
}
